type ColorVariables = {
    colors_state_open: string;
    colors_state_assigned: string;
    colors_state_resourced: string;
    colors_state_ongoing: string;
    colors_state_done: string;
    colors_state_cancelled: string;
    colors_state_paused: string;
    colors_state_failed: string;
    colors_white: string;
    colors_ultraligh: string;

    colors_gray: string;
    colors_lightgray: string;
    colors_midgray: string;
    colors_darkgray: string;

    colors_semitransparent_red: string;

    colors_red: string;
    colors_black: string;
    colors_yellow: string;
    colors_green: string;
    colors_blue: string;

    colors_orange: string;
    colors_light_green: string;
    colors_light_blue: string;
};

const GM_COLOR_VARIABLES: ColorVariables = {
    colors_state_open: '#8F94A3',
    colors_state_assigned: '#1B97D6',
    colors_state_resourced: '#671395',
    colors_state_ongoing: '#E9A403',
    colors_state_done: '#71EA48',
    colors_state_cancelled: '#000000',
    colors_state_paused: '#FDD557',
    colors_state_failed: '#FE4B3E',

    colors_white: '#FFFFFF',
    colors_ultraligh: '#F7F8F9',

    colors_gray: '#D3D3D3',
    colors_lightgray: '#D9DFE3',
    colors_midgray: '#8F94A3',
    colors_darkgray: '#373941',

    colors_semitransparent_red: '#FE4B3EEE',

    colors_red: '#FE4B3E',
    colors_black: '#121316',
    colors_yellow: '#f3b900',
    colors_green: '#71EA48',
    colors_blue: '#1B97D6',
    colors_orange: '#FFFFFF',
    colors_light_green: '#FFFFFF',
    colors_light_blue: '#FFFFFF'
};

const GCM_COLOR_VARIABLES: ColorVariables = {
    colors_state_open: '#8F94A3',
    colors_state_assigned: '#1B97D6',
    colors_state_resourced: '#671395',
    colors_state_ongoing: '#E9A403',
    colors_state_done: '#71EA48',
    colors_state_cancelled: '#000000',
    colors_state_paused: '#FDD557',
    colors_state_failed: '#FE4B3E',

    colors_white: '#FFFFFF',
    colors_ultraligh: '#F7F8F9',

    colors_orange: '#F66007',

    colors_gray: '#6f6f6e',
    colors_lightgray: '#D9DFE3',
    colors_midgray: '#8F94A3',
    colors_darkgray: '#373941',

    colors_semitransparent_red: '#FE4B3EEE',

    colors_red: '#FE4B3E',
    colors_black: '#121316',
    colors_yellow: '#f3b900',

    colors_green: '#71EA48',
    colors_light_green: '#BBC797',

    colors_blue: '#1B97D6',
    colors_light_blue: '#C2E5F4'
};

export const COLOR_VARIABLES =
    process.env.REACT_APP_THEME === 'GCM' ? GCM_COLOR_VARIABLES : GM_COLOR_VARIABLES;
